export default __webpack_public_path__ + "static/media/zoom.bea3f495.png";